import { useEffect } from "react";
import { useSnapshot } from "valtio";
import uiState from "../data.jsx";

const SharedIframe = () => {
  const { visible: trumpetVisible } = useSnapshot(uiState.trumpetIframe);
  const { visible: saxVisible } = useSnapshot(uiState.saxIframe);
  const { visible: frenchhornVisible } = useSnapshot(uiState.frenchhornIframe);
  const { visible: tromboneVisible } = useSnapshot(uiState.tromboneIframe);
  const { visible: susVisible } = useSnapshot(uiState.susIframe);

  useEffect(() => {
    const iframeStates = [
      { id: "trumpetIframe", visible: trumpetVisible },
      { id: "saxIframe", visible: saxVisible },
      { id: "frenchhornIframe", visible: frenchhornVisible },
      { id: "tromboneIframe", visible: tromboneVisible },
      { id: "susIframe", visible: susVisible },
    ];

    iframeStates.forEach(({ id, visible }) => {
      const iframe = document.getElementById(id);
      const targetWindow = iframe?.contentWindow;
      if (!targetWindow) return;

      try {
        targetWindow.postMessage(
          {
            type: "KHS_IFRAME_LIFECYCLE",
            action: visible ? "resume" : "pause",
            source: "khs_start",
            iframeId: id,
          },
          "*"
        );
      } catch (error) {
        // Keep visibility behavior stable even if a child page cannot receive messages.
      }
    });
  }, [trumpetVisible, saxVisible, frenchhornVisible, tromboneVisible, susVisible]);

  const renderIframe = ({ src, id, title, visible }) => (
    <div
      className="screen-setting fixed top-0 left-0 w-full h-[100dvh] overflow-hidden"
      style={{
        visibility: visible ? "visible" : "hidden",
        zIndex: visible ? 100 : -100,
        pointerEvents: visible ? "auto" : "none",
      }}
    >
      <iframe
        src={src}
        id={id}
        title={title}
        allow="autoplay; fullscreen; accelerometer; gyroscope;"
        style={{
          width: "1px",
          minWidth: "100%",
          height: "1px",
          minHeight: "100%",
          border: "none",
        }}
      />
    </div>
  );

  // Render all iframes up-front; control visibility without opacity.
  return (
    <>
      {renderIframe({
        src: "../factory_Trumpet/khs_factory_trumpet.html",
        id: "trumpetIframe",
        title: "trumpet iframe",
        visible: trumpetVisible,
      })}
      {renderIframe({
        src: "../factory_Sax/khs_factory_sax.html",
        id: "saxIframe",
        title: "Sax iframe",
        visible: saxVisible,
      })}
      {renderIframe({
        src: "../factory_FrenchHorn/khs_factory_frenchhorn.html",
        id: "frenchhornIframe",
        title: "Frenchhorn iframe",
        visible: frenchhornVisible,
      })}
      {renderIframe({
        src: "../factory_Trombone/khs_factory_trombone.html",
        id: "tromboneIframe",
        title: "Trombone iframe",
        visible: tromboneVisible,
      })}
      {renderIframe({
        src: "../sustainability/khs_sustainability.html",
        id: "susIframe",
        title: "Sus iframe",
        visible: susVisible,
      })}
    </>
  );
};

export default SharedIframe;
